import React, { useEffect, Component } from 'react';
import Header from './components/layout/Header';
import Hero from './components/layout/Hero';
import TrustSection from './components/sections/TrustSection';
import ComparisonSection from './components/sections/ComparisonSection';
import VehicleRecommendations from './components/sections/VehicleRecommendations';
import FinalCTA from './components/sections/FinalCTA';
import LeadForm from './components/sections/LeadForm';
import FAQ from './components/sections/FAQ';
import Footer from './components/layout/Footer';
import WhatsAppButton from './components/ui/WhatsAppButton';
import FacebookPixel from './components/tracking/FacebookPixel';
import MidPageCTA from './components/sections/MidPageCTA';
import { LanguageProvider } from './context/LanguageContext';
import { initAntiInspect } from './utils/antiInspect';
import { useEngagementTracking } from './hooks/useEngagementTracking';
export function App() {
  // Anti-inspect protection
  useEffect(() => {
    const cleanup = initAntiInspect();
    return cleanup;
  }, []);
  // Initialize engagement tracking (scroll depth & time on page)
  useEngagementTracking();
  // Script de redirección mejorado
  useEffect(() => {
    // Función para manejar el envío del formulario
    const handleFormSubmit = () => {
      console.log('Formulario enviado, configurando redirección de respaldo');
      // Establecer una bandera global para evitar redirecciones múltiples
      if (!(window as any).__FORM_SUBMIT_HANDLER_ATTACHED__) {
        ;
        (window as any).__FORM_SUBMIT_HANDLER_ATTACHED__ = true;
        // Configurar un respaldo de redirección después de 8 segundos
        setTimeout(() => {
          const formSubmitted = localStorage.getItem('formSubmitted');
          if (formSubmitted === 'true') {
            console.log('Ejecutando redirección de respaldo a WhatsApp');
            if (!(window as any).__REDIRECTED_AFTER_SUBMIT__) {
              ;
              (window as any).__REDIRECTED_AFTER_SUBMIT__ = true;
              // Backup redirect to WhatsApp (matches hybrid funnel)
              window.location.href = 'https://wa.me/18572715381?text=' + encodeURIComponent('Hola Pedro, acabo de enviar mi solicitud en la web.');
            }
          }
        }, 8000);
      }
    };
    // Adjuntar el manejador de eventos al formulario
    const form = document.getElementById('lead-form');
    if (form && form instanceof HTMLFormElement) {
      form.addEventListener('submit', handleFormSubmit, {
        once: true
      });
    }
    // Limpieza al desmontar
    return () => {
      if (form && form instanceof HTMLFormElement) {
        form.removeEventListener('submit', handleFormSubmit);
      }
    };
  }, []);
  return <LanguageProvider data-id="element-0">
      <div className="font-sans text-[#0B1220] bg-[#F8FAFC] min-h-screen w-full" data-id="element-1">
        <FacebookPixel data-id="element-2" />
        <Header data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <TrustSection data-id="element-6" />
          <ComparisonSection data-id="element-7" />
          <MidPageCTA data-id="element-8" />
          <VehicleRecommendations data-id="element-9" />
          <FAQ data-id="element-10" />
          <LeadForm data-id="element-11" />
          <FinalCTA data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
      </div>
    </LanguageProvider>;
}